import request from '@/utils/request';

export default {
  // 修改通知方式
  modifyNoticeWay: data =>
    request('/ess/user/reset/notice/method', {
      method: 'POST',
      body: data,
    }),

  // 修改用户邮箱
  modifyUserEmail: data =>
    request(`/ess/user/set/email/${data.email}`, {
      method: 'post',
    }),

  // 发送验证邮件
  sendResetEmail: data =>
    request('/oauth2/oauth/reset/email', {
      method: 'post',
      body: data,
    }),
  // 验证手机是否已经被绑定
  verifyMobileIsBind: data =>
    request(`/ess/user/check/phone/${data}`, {
      method: 'POST',
    }),

  // 修改手机获取验证码
  getCodeByBindMobile: data =>
    request(`/captcha/sms/sendCodeSmsByMobile/${data}`, {
      method: 'GET',
    }),
  // 绑定手机中手机号+验证码验证
  verifyMobileCode: data =>
    request('/captcha/sms/set/password/phone', {
      method: 'POST',
      body: data,
    }),

  // 绑定修改手机
  bindMobile: data =>
    request(`/ess/user/set/phone/${data}`, {
      method: 'POST',
    }),
  // 绑定手机号
  // bindMobilePhone: data => request(`/captcha/sms/sendCodeSms/${data}`, {
  //   method: 'POST',
  // }),
  // 绑定手机获取验证码
  bindMobilePhone: data =>
    request(`/captcha/sms/sendCodeSms/${data}`, {
      method: 'GET',
    }),
  // 获取代理人列表
  getProxyList: data =>
    request(`/ess/user/proxy/list/${data.current}/${data.page_size}`, {
      method: 'POST',
      body: data.condition,
    }),

  // 设置代理状态
  setProxy: data =>
    request('/ess/user/set/proxy', {
      method: 'POST',
      body: data,
    }),
  deleteProxy: data =>
    request('/ess/user/delete/proxy', {
      method: 'POST',
      body: data,
    }),
  // 修改头像
  modifyAvatar: data =>
    request('/ess/user/avatar/image', {
      method: 'POST',
      body: data,
    }),

  // 获取用户公司部门列表
  getOrgList: (start, end) =>
    request('/core/sm/org/list', {
      method: 'GET',
      params: {
        startDate: start,
        endDate: end,
      },
    }),
  // 获取用户公司部门列表id
  getOrgListCom: (data, start, end) =>
    request(`/core/sm/org/list/${data}`, {
      method: 'GET',
      params: {
        startDate: start,
        endDate: end,
      },
    }),
  // 获取用户公司列表
  getCompanyList: () =>
    request('/core/sm/company/list', {
      method: 'GET',
    }),

  // 查询代理人
  searchProxyList: data =>
    request(`/ess/user/q/proxy/candidate/${data.pageData.current}/${data.pageData.pageSize}`, {
      method: 'POST',
      body: data.bodyData,
    }),

  // 获取代理人一级应用菜单信息
  getProxyMenu: () =>
    request('/oauth2/privilege/proxy/menu', {
      method: 'GET',
    }),

  // 头像转换成证件照阿里云产品
  getAli: data =>
    fetch('https://alidphoto.aisegment.com/idphoto/make', {
      method: 'POST',
      headers: {
        Authorization: 'APPCODE 74a5dd148ea54155b1030a8e2b56fec0',
        'content-type': 'application/json;charset=UTF-8',
      },
      body: data,
    })
      .then(res => res.json())
      .then(res => res),

  // 将头像转成证件照研究生产品
  getImageOther: data =>
    fetch('https://apicall.id-photo-verify.com/api/cut_pic', {
      method: 'POST',
      headers: {
        'content-type': 'application/json;charset=UTF-8',
      },
      body: data,
    })
      .then(res => res.json())
      .then(res => res),

  // 获取图片信息
  getImageInfo: data =>
    fetch(`https://apicall.id-photo-verify.com/api/take_pic_wm/${data}`, {
      method: 'GET',
    }).then(res => res),

  // 将身份证信息提取
  getInfoAli: data =>
    fetch('http://idcardai.market.alicloudapi.com/thirdnode/ImageAI/idcardfrontrecongnition', {
      method: 'POST',
      headers: {
        Authorization: 'APPCODE 0fbd146766594a71a9f75a67c6d1ce68',
        'content-type': 'application/x-www-form-urlencoded;charset=UTF-8',
      },
      body: data,
    })
      .then(res => res.json())
      .then(res => res),

  // 获取传参前的参数信息
  getFileInfo: data =>
    request(`/captcha/upload/auth-upload-url/${data}`, {
      method: 'GET',
    }),

  // 改变主题颜色的接口
  changeThemeColor: data =>
    request(`/ess/user/reset/bgcolor?bgColor=%23${data.slice(1)}`, {
      method: 'post',
    }),
  // 更新邮箱
  updateEmail: data =>
    request(`/ess/user/set/email?user_id=${data.user_id}&email=${data.email}`, {
      method: 'post',
    }),
  // 修改邮箱、手机前校验
  saveEntryInduction: data =>
    request(`/core/pa/pre-saveOrUpdate/induction`, {
      method: 'post',
      body: data,
    }),
  // 重置邮箱
  verifyEmailByToken: data =>
    request(`/oauth2/oauth/reset/email/${data.tenant_id}/${data.token_id}`, {
      method: 'get',
    }),
  changeStartMenu: data =>
    request(`/core/sm/auth/user/${data}`, {
      method: 'get',
    }),
  modifyProxy: data =>
    request('/ess/user/reset/proxy', {
      method: 'post',
      body: data,
    }),
  tpMessageState: data =>
    request('/core/sm/tp/tpMessageState', {
      method: 'get',
      params: {
        tenantId: data,
      },
    }),
  //微信绑定
  wechatBind: data =>
    request(`/oauth2/binding/wechat/${data.userId}/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  //企业微信绑定
  weixinBind: data =>
    request(`/oauth2/binding/weixin/${data.userId}/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  //钉钉绑定
  dingdingBind: data =>
    request(`/oauth2/binding/dingding/${data.userId}/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  //飞书绑定
  feishuBind: data =>
    request(`/oauth2/binding/feishu/${data.userId}/${data.tenantId}`, {
      method: 'get',
      params: {
        code: data.code,
      },
    }),
  //微信解绑
  wechatUnbind: data =>
    request(`/oauth2/unbind/wechat/${data.userId}/${data.tenantId}`, {
      method: 'get',
    }),
  //企业微信解绑
  weixinUnbind: data =>
    request(`/oauth2/unbind/weixin/${data.userId}/${data.tenantId}`, {
      method: 'get',
    }),
  //钉钉解绑
  dingdingUnbind: data =>
    request(`/oauth2/unbind/dingding/${data.userId}/${data.tenantId}`, {
      method: 'get',
    }),
  //飞书解绑
  feishuUnbind: data =>
    request(`/oauth2/unbind/feishu/${data.userId}/${data.tenantId}`, {
      method: 'get',
    }),
};
